import { SyncStatus } from '@constants';
import { Prototype } from '@core';
import { useFetchDashboardARPayment } from '@hooks';
import { mapMUITableColumnsToFilterColumns } from '@utils/tableHelper';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useLocation } from 'react-router-dom';
import trans from 'translation';
import { KContainer, KLabel, KColors, KChip, KLoading } from 'uikit';

import TextFieldSearch from 'components/TextFieldSearch';

import { getSearchField } from '../helper';

type Props = {
  tabName: string;
};

const ARPayments = (props: Props) => {
  const { tabName } = props;

  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement>();

  const [searchField, setSearchField] = useState('keyword');

  const [searchValue, setSearchValue] = useState('');

  const {
    dataFlatten: data = [],
    isLoading,
    hasNextPage,
    onEndReached
  } = useFetchDashboardARPayment({
    source: searchField === 'keyword' ? undefined : searchField,
    keyword: searchValue
  });

  useEffect(() => {
    if (location.state?.scrollToBottom) {
      window.history.replaceState({}, document.title);
      console.log(scrollRef);
      scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.state]);

  const renderRow = useCallback((item: any) => {
    return (
      <KContainer.View
        key={item.code}
        marginB={'0.5rem'}
        background={'#F8F9FA'}
        br={'2x'}
        padding={'0.75rem'}
      >
        <KContainer.View row alignItems>
          <KContainer.View row alignItems flex={3}>
            <KLabel.Text typo="TextMdMedium" marginR={'1.5rem'}>
              {/* {`Payment ${item.code}`} */}
              {trans('payment_code', { code: item.code })}
            </KLabel.Text>
          </KContainer.View>

          <KContainer.View row flex={1.2} dp="flex" justifyContent="flex-end">
            {/* {item.paymentProgress && (
              <KChip
                background="#FFF1E0"
                br="x"
                brW={1}
                width={60}
                height={25}
                brC="#FB8C01"
                color="#FB8C01"
                label={item.paymentProgress.name}
              />
            )} */}

            <KChip
              background="#DDF7F5"
              br="x"
              brW={1}
              width={70}
              height={25}
              brC="#13A89E"
              color="#13A89E"
              marginL="0.25rem"
              label={
                (item?.syncStatus === SyncStatus.Success.toUpperCase()
                  ? trans('synced').toUpperCase()
                  : item?.syncStatus) ?? trans('unsynced').toUpperCase()
              }
            />
          </KContainer.View>
        </KContainer.View>

        <KContainer.View row alignItems>
          <KLabel.Text typo="Text2xLgMedium" marginB={'0.25rem'}>
            {Prototype.number.formatCurrency(item.totalAmount)}
          </KLabel.Text>
        </KContainer.View>

        <KContainer.View row alignItems>
          <KLabel.Text color={'#7B809A'}>
            {trans('account_receivable')}:
            <KLabel.Text
              typo="TextNmBold"
              color={KColors.primary.normal}
              isLink
              to={`/admin/clients/${item?.clientId ?? item?.client?.id}`}
              target="_blank"
            >
              {item?.client?.name}
            </KLabel.Text>
          </KLabel.Text>
        </KContainer.View>

        <KContainer.View row alignItems>
          <KContainer.View flex={1.5}>
            <KLabel.Text color={KColors.primary.normal} typo="TextNmBold">
              {`${trans('payment_date')}: ${Prototype.date.toLocal(item.paymentDate)?.format('DD/MM/YYYY')}`}
            </KLabel.Text>
          </KContainer.View>

          <KContainer.View flex={1.2}>
            <KLabel.Text typo="TextNmNormal">
              {`${trans('payment_method')}: ${trans(`option.${item.paymentType?.toLowerCase()}`)}`}
            </KLabel.Text>
          </KContainer.View>
        </KContainer.View>
      </KContainer.View>
    );
  }, []);

  return (
    <KContainer.View
      // height={DASHBOARD_CONTENT_HEIGHT - 12 * 2}
      marginT={0}
      // isLoading={isLoading}
      // header={{
      //   title: trans('accounts_receivable_overdue'),
      //   typo: 'TextMdBold'
      // }}
      ref={scrollRef as any}
      dp="flex"
      alignItems="stretch"
      flexG={1}
    >
      <KContainer.View marginB="0.5rem">
        <TextFieldSearch
          columns={getSearchField(tabName)}
          handleSearchValue={setSearchValue}
          handleChangeSearchField={setSearchField}
          mapColumns={mapMUITableColumnsToFilterColumns}
        />
      </KContainer.View>
      <KContainer.View
        id="ARPaymentsNotificationDiv"
        flex
        overflow
        position="relative"
      >
        <InfiniteScroll
          height={'100vh'}
          dataLength={data.length}
          next={onEndReached}
          hasMore={hasNextPage as any}
          loader={isLoading ? <KLoading /> : null}
          scrollableTarget="ARPaymentsNotificationDiv"
          scrollThreshold={0.5}
        >
          {data?.map(i => renderRow(i))}
        </InfiniteScroll>
      </KContainer.View>
    </KContainer.View>
  );
};

export default memo(ARPayments);
